var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({staticClass:"mt-1",attrs:{"auto-grow":"","rows":_vm.rows,"id":_vm.name,"outlined":""},on:{"input":_vm.clearServerErrors}},'v-textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }